import { CvExportsButton } from "PFApp/components/cv_exports_button";
import { LegacyLazyLocalExportTrigger } from "PFApp/legacy_cv_export_flow";
import { Icon } from "PFComponents/icon";
import { Tabs } from "PFComponents/tabs";
import { useRoleName } from "PFCore/helpers/activities";
import useIsFeatureEnabled from "PFCore/helpers/use_is_feature_enabled";
import { useIsUnbiasedMode } from "PFCore/hooks/use_is_unbiased_mode";
import { Activity, FeatureFlag } from "PFTypes";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router";

import { ComparableProfile } from "../details/parts/use_cell_data";
import css from "./compare_header.module.scss";
import { getLegacyCvExportProfilesCollection } from "./legacy_cv_export_profiles_collection";

type CompareHeaderProps = {
  activity: Activity;
  tabActiveId: "details" | "availability";
  changeTab: (tab: string) => void;
  comparableProfiles: ComparableProfile[];
};

export const CompareHeader = ({
  activity,
  tabActiveId,
  changeTab,
  comparableProfiles
}: CompareHeaderProps) => {
  const { t } = useTranslation("activities");
  const { t: tTranslation } = useTranslation();
  const getRoleName = useRoleName();
  const location = useLocation();
  const isEnabled = useIsFeatureEnabled();
  const isLegacyCvExport = isEnabled(FeatureFlag.CVExportLegacyFlow);
  const isUnbiasedMode = useIsUnbiasedMode(activity?.reviewers);
  const TABS = [
    { id: "details", title: t("compare.compareDetails") },
    { id: "availability", title: t("compare.compareAvailabity") }
  ];

  const prevPath = useRef(location.state?.prevPath);
  return (
    <div className={css.root}>
      <div className={css.header}>
        <Link className={css.back} to={prevPath.current || `/activities/${activity.id}/shortlist`}>
          <Icon name="chevron-left" size="xxs" />
          {t("compare.exitCompare")}
        </Link>
        {isLegacyCvExport ? (
          <LegacyLazyLocalExportTrigger
            buttonKind="primary"
            quantity={comparableProfiles?.length || 0}
            getProfilesCollection={getLegacyCvExportProfilesCollection(comparableProfiles, activity.id)}
            isBlindModeOn={isUnbiasedMode}
          />
        ) : (
          <CvExportsButton
            profileIds={comparableProfiles.map(({ profile }) => profile.id)}
            activityId={activity.id}
            text={tTranslation("exportText")}
            icon={undefined}
            kind="primary"
          />
        )}
      </div>

      <div className={css.row}>
        <div className={css.tabs}>
          <Tabs onChange={changeTab} tabs={TABS} activeTab={tabActiveId} />
        </div>
        {activity && activity.name && <h1 className={css.name}>{getRoleName(activity)}</h1>}
      </div>
    </div>
  );
};
